import { CreditRecord } from '@/api_client/types/credit_records'

export const deserializeCreditRecord = (data): CreditRecord => {
  if (data == null) {
    return null
  }
  let purchase = null
  if (data.purchase) {
    purchase = {
      product_name: data.purchase.product.name,
      product_uuid: data.purchase.product.uid,
    }
  }
  return {
    id: data.id,
    user_id: data.user_id,
    purchase: purchase,
    credits: data.credits,
    used_credits: data.used_credits,
    available_credits: data.available_credits,
    status: data.status,
    expires_date: data.expires_date,
    created_at: data.created_at,
  }
}
